export const nav = [
  ["dashboard", "◫", "Dashboard"],
  ["products", "▦", "Products"],
  ["collections", "◈", "Collections"],
  ["orders", "▣", "Orders"],
  ["payments", "◉", "Payments"],
  ["customers", "♙", "Customers"],
  ["coupons", "◇", "Coupons"],
  ["settings", "⚙", "Content / Settings"],
];
